<template>
  <v-container fluid>
    <v-stepper v-model="step"
               alt-labels
               class="VV_Stepper mb-2">
      <v-stepper-header>
        <v-stepper-step step="1"
                        :complete="step > 1">
          <template v-if="connection">
            {{ pepperFlowConnection.name }}
          </template>
          <template v-else>
            Select Pepper Flow Filter
          </template>
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="2"
                        :complete="step > 2">
          <template v-if="documents.length">
            {{ documents.length | pluralize('document') }} selected
          </template>
          <template v-else>
            Select Documents
          </template>
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="3"
                        :complete="step > 3">
          Groups & Permissions
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="4"
                        :complete="step > 4">
          Folders & Tags
        </v-stepper-step>

        <v-divider></v-divider>

        <v-divider></v-divider>

        <v-stepper-step step="5"
                        :complete="step > 5">
          Review
        </v-stepper-step>

      </v-stepper-header>
    </v-stepper>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {find} from 'lodash';

export default {
  computed: {
    ...mapGetters('pepperFlow', [
      'connections',
    ]),
    ...mapGetters('pepperFlowCart', [
      'connection',
      'documents',
      'folder',
      'groups',
      'labels',
      'step',
    ]),
    pepperFlowConnection() {
      return find(this.connections, c => c.id === this.connection);
    }
  },
}
</script>
